$(document).on('turbolinks:load', function() {
  let activeDate;
  let activeTrack;

  $('.js-speaker-filters-dropdown-container').hide();
  $(".spekears-filters-content .btn-filter").click(function() {
      let dropdown = $(this).attr('aria-controls');
      $('.js-speaker-filters-dropdown-container').each(function() {
        $container = $(this);
        if($(this).attr('id') === dropdown){
          $container.toggle();
        } else {
          $container.hide();
        }
      });
  });

  $(".js-dropdown-item").click(function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
  });
  
  $(".js-speaker-filter").click(function() {
    let filterType = $(this).data('filtertype');
    if(filterType == 'date'){
      activeDate = $(this).data('date');
    } else {
      activeTrack = $(this).data('trackid');
    }
    filterSpeakers();
  });

  function filterSpeakers(){
    $(".js-speaker-preview").each(function() {
      let $speaker = $(this);
      let validDate = (activeDate == undefined) || $speaker.data("days").includes(activeDate);
      let validTrack = (activeTrack == undefined) || $speaker.data("tracks").includes(activeTrack);
      if(validDate && validTrack){
        $speaker.show();
      } else {
        $speaker.hide();
      }
    });
  }
});


